import React, { useState } from "react";
import { NavDropdown } from "react-bootstrap";
import "./Faq.css";
import { getData } from "app/data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import WaitingFor from "components/Banner/WaitingFor";
import { FormattedMessage } from "react-intl";

// Background Images
import { ReactComponent as RedTriangle } from "images/background/hero-section-red-triangle.svg";
import { ReactComponent as RedSquare } from "images/background/software-solution-graphic-red.svg";
import { ReactComponent as LeftBox } from "images/background/left-box-graphic.svg";
import { ReactComponent as RightBox } from "images/background/right-box-graphic.svg";

import { useSelector } from "react-redux";
// import { changeLanguage } from "slices/settings";

export default function Index({ faqpost, faqpost_en, faqpost_zh, fromServiceRate }) {
  // const faqData = getData("faqs").questions;
  // const [activeId, setActiveId] = useState();
  const lan = useSelector((state) => state?.settings?.lan ?? "en");
  // const dispatch = useDispatch();

  return (
    <>
      <div className="faq-page">
        <RedTriangle className="red-triangle" />
        <RightBox className="right-box-shape" />
        <RedSquare className="red-square" />
        {fromServiceRate ? null :
          <section className="container row mx-auto">
            <div className="title col-lg-12">
              <h1>
                <FormattedMessage id="faq_tpage_tile" />
              </h1>
            </div>
          </section>}


        <section className="main-background">
          {fromServiceRate ?
            <section className="container row mx-auto">
              <div className="title col-lg-12">
                <h1>
                  <FormattedMessage id="faq_tpage_tile" />
                </h1>
              </div>
            </section> : null}
          <div className="contents">
            <RightBox className="right-box-shape" />
            <LeftBox className="left-box-shape" />
            {faqpost_en && faqpost_zh
              ? lan === "en"
                ? faqpost_en.map((post) => (

                  <>
                    <ul>
                      <li className="container row mx-auto">
                        <div className="faq col-lg-12">
                          <span className="icon">
                            <FontAwesomeIcon icon={faChevronDown} />
                          </span>
                          <NavDropdown
                            title={post.title.rendered}
                            aria-controls="responsive-navbar-nav"
                            className="navbar-expand-sm"
                            onClick={() => {
                            }}
                          >
                            <div className="faq-content">
                              {Array.isArray(post.content.rendered) ?
                                <div dangerouslySetInnerHTML={{ __html: post.content.rendered.join("") }} ></div>
                                :
                                <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} ></div>
                              }

                              {/* <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} >
                              </div> */}
                            </div>
                            <hr />
                          </NavDropdown>
                        </div>
                        <hr />
                      </li >
                    </ul>
                  </>
                ))
                : lan === "zh"
                  ? faqpost_zh.map((post) => (
                    <>
                      <ul>
                        <li className="container row mx-auto">
                          <div className="faq col-lg-12">
                            <span className="icon">
                              <FontAwesomeIcon icon={faChevronDown} />
                            </span>
                            <NavDropdown
                              title={post.title.rendered}
                              aria-controls="responsive-navbar-nav"
                              className="navbar-expand-sm"
                              onClick={() => {
                              }}
                            >
                              {/* <div className="faq-content">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: post.content.rendered,
                                  }}
                                ></div>
                              </div> */}

                              {/* modified code */}
                              <div className="faq-content">
                                {Array.isArray(post.content.rendered) ?
                                  <div dangerouslySetInnerHTML={{ __html: post.content.rendered.join("") }} ></div>
                                  :
                                  <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} ></div>
                                }
                              </div>
                              {/* modified code */}

                              <hr />
                            </NavDropdown>
                          </div>
                          <hr />
                        </li>
                      </ul>
                    </>
                  ))
                  : null
              : null}
          </div>
        </section >
        <WaitingFor />
      </div >
    </>
  );
}
